import * as React from "react";

import { DetailContainer } from "../common/detail-container";
import { IngestionMessage } from '../../../../../../../services/publisher-notifications/types/ingestion-message';

import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

interface ReleaseDetailMessagesProps {
  messages: IngestionMessage[]
}

export const ReleaseDetailMessages: React.FC<ReleaseDetailMessagesProps> = (
  props
) => {
  return (
    <DetailContainer>
      {
        props.messages.map((message, i) => (
          <Accordion key={i}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              id={`panel-header-${i}`}
            >
              <Typography>{message.date.toDateString()}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography style={{whiteSpace: 'pre-line'}}>{message.message}</Typography>
            </AccordionDetails>
          </Accordion>
        ))
      }
    </DetailContainer>
  );
};
